import { FC } from "react";
import { ICancellationStats } from "../../../models/statistcs/respons";
import CancellationStatsCard from "../cancellation-stats-card";

interface IProps {
  stats?: ICancellationStats;
  onChange: (stats: ICancellationStats) => void;
  hideDateControls?: boolean;
}

const AdministrativeCancellationStats: FC<IProps> = ({
  stats,
  onChange,
  hideDateControls,
}) => (
  <CancellationStatsCard
    stats={stats}
    onChange={onChange}
    hideDateControls={hideDateControls}
    titleKey="administrative_cancellation_stats"
    cancelledField="administrativeCancelledCount"
    cancelledLabelKey="administrative_cancelled_orders"
    showCauses
  />
);

export default AdministrativeCancellationStats;
